'use strict';
const angular = require('angular');

/*@ngInject*/
export function startFromFilter() {
  return function(input, start) {
    start = +start;
    return input.slice(start);
  };
}


export default angular.module('conduu.startFromFilter', [])
  .filter('startFrom', startFromFilter)
  .name;



// WEBPACK FOOTER //
// ./client/components/start-from/startFrom.filter.js